// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-reminder-dialog__text[data-v-3c81e2a9]{margin-bottom:16px}.region-reminder__error[data-v-3c81e2a9]{color:#b00020;margin-top:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
